
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Bell } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

interface NotificationSettingsSectionProps {
  settings: {
    emailNotifications: boolean;
    smsNotifications: boolean;
  };
  updateSetting: (key: string, value: any) => void;
}

const NotificationSettingsSection = ({ settings, updateSetting }: NotificationSettingsSectionProps) => {
  const { t } = useLanguage();

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Bell className="h-5 w-5" />
          {t('notifications', 'الإشعارات', 'Notifications')}
        </CardTitle>
        <CardDescription>
          {t('notification_settings', 'إعدادات الإشعارات', 'Configure system notification preferences')}
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label>{t('email_notifications', 'إشعارات البريد الإلكتروني', 'Email Notifications')}</Label>
            <p className="text-sm text-muted-foreground">
              {t('send_email_notifications', 'إرسال الإشعارات عبر البريد الإلكتروني', 'Send notifications via email')}
            </p>
          </div>
          <Switch
            checked={settings.emailNotifications}
            onCheckedChange={(checked) => updateSetting('emailNotifications', checked)}
          />
        </div>
        
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label>{t('sms_notifications', 'إشعارات الرسائل النصية', 'SMS Notifications')}</Label>
            <p className="text-sm text-muted-foreground">
              {t('send_sms_notifications', 'إرسال الإشعارات عبر الرسائل النصية', 'Send notifications via SMS')}
            </p>
          </div>
          <Switch
            checked={settings.smsNotifications}
            onCheckedChange={(checked) => updateSetting('smsNotifications', checked)}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default NotificationSettingsSection;
